import {TASKSTATISTIC} from 'Constants/ActionTypes';

const {
  POST_TASK_STATISTIC_LIST,
  POST_TASK_STATISTIC_EXPORT,
  POST_TASK_STATISTIC_TOTAL,
} = TASKSTATISTIC;
// 通用前缀
const url = '/robot';

const actions = {
  // 任务管理-任务统计-列表
  postTaskStatisticList(data) {
    return {
      type: POST_TASK_STATISTIC_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/statistic`,
          data,
        },
      },
    };
  },
  // 任务管理-任务统计-总计
  getTotal(data) {
    return {
      type: POST_TASK_STATISTIC_TOTAL,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/statisticAggregate`,
          data,
        },
      },
    };
  },
  // 任务管理-任务统计-导出
  exportTask(data) {
    return {
      type: POST_TASK_STATISTIC_EXPORT,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/statistic/sync/export`,
          data,
        },
      },
    };
  },
};

export default actions;
